export const tab = (data) => {
	return [
		{
			key: 'unread',
			tab: 'No Leídas',
			data: data,
			seen: false,
		},
		{
			key: 'read',
			tab: 'Leídas',
			data: data,
			seen: true,
		},
		{
			key: 'all',
			tab: 'Todas',
			data: data,
			seen: null,
		},
	];
};
